export const Tier = {
    Gold: '0',
    Silver: '1',
    Bronze: '2',
  };